import type { AuthFetch } from '../types';

/**
 * Módulo Rede — cliente do backend EXTERNO.
 *
 * Esse backend roda separado (VPS próprio) e tem autenticação própria; o
 * painel só consome. Nada aqui passa pela API do Farisx, então o token da
 * sessão do painel não vale — o módulo mantém a sessão dele.
 */
const envApi = (import.meta.env.VITE_REDE_API_BASE_URL || '').trim();

export const API_BASE_URL = envApi || 'https://ativa.promind.dev.br/api';

/** Cria um fetch autenticado que injeta o Bearer token e trata erros do backend. */
export function createAuthFetch(getToken: () => string | undefined): AuthFetch {
  return async <T = unknown>(path: string, options: RequestInit = {}, tokenOverride?: string): Promise<T> => {
    const token = tokenOverride || getToken();
    if (!token) throw new Error('Sessao invalida.');
    const response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: { ...(options.headers || {}), Authorization: `Bearer ${token}` }
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error((data as { message?: string }).message || 'Erro no backend.');
    return data as T;
  };
}
